import React, { useEffect, useState } from 'react';

const Toast = ({ message, type = 'info', onClose }) => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    // Show the toast
    setVisible(true);

    // Auto close after 4 seconds
    const timer = setTimeout(() => {
      setVisible(false);
      setTimeout(onClose, 300); // Wait for animation to end
    }, 2500);

    return () => clearTimeout(timer);
  }, [onClose]);

  return (
    <div className={`toast ${type} ${visible ? 'show' : ''}`}>
      <span>{message}</span>
      <span className="close-btn-toast" onClick={() => {
        setVisible(false);
        setTimeout(onClose, 300);
      }}>×</span>
    </div>
  );
};

export default Toast;
